import { useState } from 'react';
import UploadFile from '../../../components/ui/UploadFile';
import { OrderService } from '../../../core/services/order.service';
import { useAppDispatch } from '../../../libs/hook';
import { hideSpinner, showSpinner } from '../../../libs/features/spinnerSlice';
import { toast } from 'react-toastify';
import { FileService } from '../../../core/services/common/file.service';

type ImportFileModalProps = {
  onSubmit?: (event: any) => void;
  onClose?: (event?: any) => void;
};

export default function ImportFileModal(props: ImportFileModalProps) {
  const dispatch = useAppDispatch();
  const [images, setImages] = useState<any[]>([]);
  const [excelFile, setExcelFile] = useState<any>();

  const onChangeExcel = (event: any) => {
    setExcelFile(event.filesToAdd[0]);
  };

  const onChangeImage = (event: any) => {
    setImages(event.filesToAdd);
  };

  const onSubmitForm = () => {
    if (!excelFile) {
      toast.error('Chưa có file excel');
      return;
    }
    if (!images || images?.length <= 0) {
      toast.error('Chưa có hình ảnh');
      return;
    }
    dispatch(showSpinner());
    OrderService.createOrUpdateFormFile(excelFile, images)
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        if (res.data.status == 'NG') {
          const lines = res.data.message.split('\n');
          const formattedMessage = <div>{lines?.map((line: any, index: any) => <>{line.trim()?.length > 0 && <div key={index}>- {line}</div>}</>)}</div>;
          toast.error(formattedMessage);
          return;
        }
        if (res.data.status == 'WN') {
          const lines = res.data.message.split('\n');
          const formattedMessage = (
            <div>
              <>Lưu thành công.</>
              {lines?.map((line: any, index: any) => <>{line.trim()?.length > 0 && <div key={index}>- {line}</div>}</>)}
            </div>
          );
          toast.warning(formattedMessage);
          props.onClose?.(true);
          return;
        }
        props.onClose?.(true);
      });
  };

  const downloadFile = () => {
    dispatch(showSpinner());
    FileService.downloadImportTemplate()
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        // Tạo một URL từ blob
        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link: any = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'mau-nhap-kho.xlsx'); // Đặt tên file Excel

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      });
  };

  return (
    <>
      <div className="modal-body">
        <div className="row">
          <div className="col-12 pt-3">
            <div className="mb-2 text-danger">Lưu ý nội dung file Excel và ảnh:</div>
            <div>
              <ul>
                <li className="text-danger">Ngày nhập kho là bắt buộc.</li>
                <li className="text-danger">Ngày nhập kho phải là kiểu "Text" trong Excel, có định dạng là: dd/mm/yyyy (vd: 01/06/2024).</li>
                <li className="text-danger">Mã đơn hàng là bắt buộc.</li>
                <li className="text-danger">Số kiện là bắt buộc.</li>
                <li className="text-danger">Tên ảnh là &lt;mã đơn hàng&gt; đối với mã có 1 ảnh, và &lt;mã đơn hàng&gt;_&lt;stt&gt; nếu mã có nhiều ảnh.</li>
              </ul>
            </div>
          </div>
          <div className="col-12 py-3">
            <div className="text-heading mb-2 d-flex justify-content-between">
              <div>Tệp Excel</div>
              <div className="badge rounded-pill bg-primary cursor-pointer" onClick={downloadFile}>
                Tải file mẫu
              </div>
            </div>
            <UploadFile onChange={onChangeExcel} accept=".xlsx, .xls" multiple={false}></UploadFile>
          </div>
          <div className="col-12 py-3">
            <div className="text-heading mb-2">
              Hình ảnh các đơn hàng
              {/* <span className="badge rounded-pill bg-primary">Tên ảnh là <span className='fst-italic'>Mã đơn hàng</span> đối với mã có 1 ảnh và <span className='fst-italic'>mã đơn hàng_stt</span> nếu mã có nhiều ảnh</span> */}
            </div>
            <UploadFile onChange={onChangeImage} accept="image/*" multiple></UploadFile>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-outline-secondary waves-effect" onClick={() => props.onClose?.(false)}>
          Hủy
        </button>
        <button type="button" className="btn btn-primary waves-effect waves-light" onClick={onSubmitForm}>
          Thêm
        </button>
      </div>
    </>
  );
}
